import { render, staticRenderFns } from "./BrowserRuleManage.vue?vue&type=template&id=6cf67119&scoped=true"
import script from "./BrowserRuleManage.vue?vue&type=script&lang=ts"
export * from "./BrowserRuleManage.vue?vue&type=script&lang=ts"
import style0 from "./BrowserRuleManage.vue?vue&type=style&index=0&id=6cf67119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf67119",
  null
  
)

export default component.exports